/**
 * Smooth Scroll-to Links
 * -------------------------------------------------- */

$('.js-scroll-to').click(function() {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') ||
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html,body').animate(
        {
          scrollTop: target.offset().top
        },
        750
      );
      return false;
    }
  }
});


$('a[href^="#"]').on('click', function(event) {
  event.preventDefault();
  scrollToPos($($(this).attr('href')));
});

function scrollToPos(scrollTarget) {

  if (scrollTarget.length) {
     $('html, body').animate({
        scrollTop: scrollTarget.offset().top
     }, 750);
  }

}